var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mpn-list",attrs:{"id":"mpn-list"}},_vm._l((_vm.products),function(item,i){return _c(_vm.currentItemComponent,{key:i,tag:"component",attrs:{"product":item}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-934e832e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ProductList.vue
// module id = 35
// module chunks = 0